// extracted by mini-css-extract-plugin
export default {"avatar":"zN7QB","smallMobile":"O0vex","mobile":"K4ZU5","tablet":"U3uuV","desktop":"PLiiK","diamond":"oUtXf","userInfo":"mLGx8","name":"g10Su","points":"qMbNm"};